import { Component, OnInit } from '@angular/core';
import { DataService } from '../../providers/data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loading: boolean = false;
  private redirect: string;

  constructor(
    public dataService: DataService,
    private route: ActivatedRoute,
    private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.redirect = params['returnUrl'];
      });
  }

  login() {
    this.loading = true;
    this.dataService.login(this.dataService.user).subscribe(
      user  => {
        this.loading = false;
        this.dataService.login_error = false;
        this.router.navigate([this.redirect])
      },
      error => {
        this.loading = false;
        this.dataService.login_error = true;
      }
    );
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/login/login.component.ts